'use client';

import { i18n } from '@/i18n-config';
import { usePathname } from '@/navigation';
import {
  ApplicationType,
  ComponentBuilderClient,
  ComponentTemplate,
} from '@into-discovery/browsewebshared';

type Props = {
  pageProps: any;
};

export default function OrderedPageProvider({ pageProps }: Props) {
  const pathname = usePathname();
  const componentBuilderClient = new ComponentBuilderClient();
  const template = componentBuilderClient.getPageTemplate(
    pageProps.data,
    pageProps.appSettings,
    pageProps.pageType,
  );
  return (
    <ComponentTemplate
      template={template}
      pagePath={pathname}
      locales={i18n.locales}
      application={ApplicationType.IntoStudy}
    />
  );
}
